// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2csA8","col":"CardReaderDesc_col__3NvAh","label":"CardReaderDesc_label__EzwDg"};